"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.iterator.some.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _moment = _interopRequireDefault(require("moment"));
var _followUps = require("@/api/follow-ups");
var _samplesLeadsProducts = require("@/api/samples-leads-products");
var _samples = require("@/api/samples");
var _leads = require("@/api/leads");
var _transporters = require("@/api/transporters");
var _leadsProducts = require("@/api/leads-products");
var _index = require("@/utils/index");
var _agendaLabels = require("@/utils/agendaLabels");
var _index2 = _interopRequireDefault(require("@/components/Enabled/index.vue"));
var _router = _interopRequireDefault(require("@/router"));
var _admin = require("@/store/modules/admin");
var _reasons = require("@/api/master/reasons");
var _FollowUpTimer = _interopRequireDefault(require("./components/FollowUpTimer.vue"));
var _index3 = _interopRequireDefault(require("@/components/FileUpload/index.vue"));
var _clientsContacts = require("@/api/clients-contacts");
let default_1 = class extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.agendaLabels = _agendaLabels.agendaLabels;
    this.tableKey = 0;
    this.total = 0;
    this.now = Date.now();
    this._nowTimer = null;
    this.followupList = [];
    this.sampleFollowupList = [];
    this.listLoading = true;
    this.loading = false;
    this.activeName = ['Lead', 'Product'];
    this.leadId = null;
    this.lead = null;
    this.productList = [];
    this.sampleProductList = [];
    this.loggedInUser = null;
    this.clientActionDialogVisible = false;
    this.quoteReceivedDialogVisible = false;
    this.quoteReceivedDialogTitle = '';
    this.sourceDialogVisible = false;
    this.clientOptionActionDialogVisible = false;
    this.leadRejectReason = '';
    this.leadRejectReasonComment = '';
    this.optionRejectReason = '';
    this.quoteReviseReason = '';
    this.quoteReviseReasonComment = '';
    this.approveFormVisible = false;
    this.rejectFormVisible = false;
    this.reviseFormVisible = false;
    this.reviseOptionFormVisible = false;
    this.rescheduleFollowupVisible = false;
    this.snoozeFollowupVisible = false;
    this.reasonList = [];
    this.reasonId = null;
    this.getPODialogVisible = false;
    this.sampleTitle = '';
    this.resend = false;
    this.resendComments = null;
    this.rescheduleReason = '';
    this.coordinatorName = '';
    this.selectedDate = '';
    this.lostInquiryFormVisible = false;
    this.emailPrefWarningVisible = false;
    this.mobilePrefWarningVisible = false;
    this.formattedCreatedDate = '';
    this.rejectLoading = false;
    this.approveLoading = false;
    this.dialogTableVisible = false;
    this.dialogSampleFollowUpVisible = false;
    this.selectedSampleLeadProducts = [];
    this.resheduleReasons = [];
    this.fileList = [];
    this.images = [];
    // sample-follow-up
    this.sample = Object.assign(_samples.defaultSampleData);
    this.customProduct = false;
    this.rejectReason = '';
    this.transporters = [];
    this.selectedreturnProducts = [];
    this.selectedGoodReturnProducts = [];
    this.typeList = [{
      label: 'Inquiry',
      value: 'Lead'
    }];
    this.sampleListQuery = {
      leadId: this.leadId,
      enabled: true,
      sort: 'id,DESC',
      filter: {
        leadId: '$eq',
        enabled: '$eq'
      }
    };
    this.statusColorMap = {
      Snoozed: 'info',
      Pending: 'warning',
      Completed: 'success',
      Missed: 'danger'
    };
    this.listQuery = {
      page: 1,
      limit: 25,
      leadId: this.leadId,
      type: 'Lead',
      enabled: true,
      sort: 'id,DESC',
      filter: {
        leadId: '$eq',
        enabled: '$eq',
        type: '$eq'
      }
    };
    this.datePickerOptions = {
      disabledDate(time) {
        // Disables all dates before today
        // 8.64e7 is one day in milliseconds (24 * 60 * 60 * 1000)
        return time.getTime() < Date.now() - 8.64e7;
      }
    };
    // private async productSourced() {
    //   await productSourced({ id: this.leadId })
    //   // refresh follow-up list
    //   this.getList()
    // }
    this.pickerOptions = {
      disabledDate(time) {
        return time.getTime() <= Date.now() - 8.64e7;
      }
    };
    this.reschedulePickerOptions = {
      disabledDate(time) {
        const tomorrow = new Date();
        // // Set tomorrow's date by adding 1 day to the current date
        // tomorrow.setDate(tomorrow.getDate() + 1);
        // Disable dates before tomorrow
        return time.getTime() < tomorrow.getTime();
      }
    };
    this.selectedFollowup = {};
  }
  formatIndianDate(dateStr) {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    const hh = String(d.getHours()).padStart(2, '0');
    return `${dd}/${mm}/${yyyy}`;
  }
  created() {
    this.leadId = parseInt(this.$route.params && this.$route.params.leadId);
    // fetch follow-ups
    this.getList();
    this.getResheduleReasons();
    this.fetchData();
    this.fetchTransporterList();
    this.fetchReasonList();
    this.loggedInUser = _admin.AdminModule;
  }
  mounted() {
    this._nowTimer = setInterval(() => {
      this.now = Date.now();
    }, 1000);
  }
  beforeDestroy() {
    clearInterval(this._nowTimer);
  }
  get leadStats() {
    const list = this.followupList || [];
    const revisedCount = list.filter(f => f.agenda === 'Revise Options' || f.agenda === 'Revise quote').length;
    const lostAfterReaction = list.filter(f => f.agenda === "Confirm client's reaction on Quote" && f.status === 'Completed' && this.lead.status === 'Lost').length;
    const quoteApprovedThenLost = list.some(f => f.agenda === 'Get Purchase Order') && this.lead.status === 'Lost';
    const wonFollowup = list.find(f => f.agenda === 'Get Purchase Order' && f.status === 'Completed');
    const wonDate = this.lead.wonDate || (wonFollowup ? wonFollowup.completedTimestamp : null);
    return {
      rejectedCount: lostAfterReaction + revisedCount,
      revisedCount,
      rejectedAfterApproval: quoteApprovedThenLost,
      wonDate
    };
  }
  get displayFollowupList() {
    let firstPendingFound = false;
    return this.followupList.map(followup => {
      // Clone the object so we don't mutate your original state/props directly
      const item = {
        ...followup
      };
      if (item.status !== 'Completed') {
        if (!firstPendingFound) {
          // This is the top-most (newest) pending item. Keep it pending and actionable.
          firstPendingFound = true;
        } else {
          // A newer pending item exists above this one. Treat this obsolete task as completed.
          item.status = 'Completed';
        }
      }
      return item;
    });
  }
  async getList() {
    try {
      this.listLoading = true;
      // assign leadId
      this.listQuery.leadId = this.leadId;
      // fetch follow-ups
      if (_admin.AdminModule.roles.toString() === 'Dispatcher') {
        this.listQuery.type = 'Sample';
      }
      const data = await (0, _followUps.getFollowUps)((0, _index.getQuery)(this.listQuery));
      // this.listQuery.type = 'Sample'
      // const sampleFollowUpdata: any = await getFollowUps(getQuery(this.listQuery))
      this.followupList = data.data;
      // this.sampleFollowupList = sampleFollowUpdata.data
      this.total = data.total;
      // get lead info
      this.lead = await (0, _leads.getLeadById)(this.leadId);
      this.formattedCreatedDate = new Date(this.lead.createdTimestamp);
      // date shifting for IST timezone (+5 hours and 30 minutes)
      this.formattedCreatedDate.setHours(this.formattedCreatedDate.getHours() + 5);
      this.formattedCreatedDate.setMinutes(this.formattedCreatedDate.getMinutes() + 30);
      // get lead products
      this.productList = await (0, _leadsProducts.getLeadsProducts)((0, _index.getQuery)({
        leadId: this.leadId,
        filter: {
          leadId: '$eq'
        }
      }));
      this.sampleProductList = [...this.productList];
      this.sampleProductList.forEach(item => {
        item.product.quantity = 1;
        this.images.push([]);
      });
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  async fetchReasonList(module = 'Quote') {
    try {
      this.reasonList = await (0, _reasons.getReasons)((0, _index.getQuery)({
        enabled: true,
        sort: 'id,ASC',
        module: module,
        filter: {
          enabled: '$eq',
          module: '$eq'
        }
      }));
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async getResheduleReasons() {
    this.resheduleReasons = await (0, _followUps.getResheduleReasons)((0, _index.getQuery)({
      module: 'Reschedule',
      filter: {
        module: 'eq'
      }
    }));
  }
  async snoozeFollowup(followup) {
    try {
      this.listLoading = true;
      if (followup) {
        const res = await (0, _followUps.snoozeFollowUp)({
          id: followup.id
        }, followup.id);
        // fetch follow-up list
        if (res && res.status === 'success') {
          this.followupList = [];
          await new Promise(resolve => setTimeout(resolve, 300));
          await this.getList();
          this.now = Date.now();
          this.$notify({
            title: 'Success',
            type: 'success',
            message: 'Follow up snoozed'
          });
        }
      } else {
        this.$notify({
          title: 'Warning',
          type: 'warning',
          message: 'Something went wrong, please try again later'
        });
      }
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    } finally {
      this.snoozeFollowupVisible = false;
      this.listLoading = false;
    }
  }
  async rescheduleFollowup(followup) {
    if (!followup) {
      this.$notify({
        title: 'Warning',
        type: 'warning',
        message: 'Something went wrong'
      });
      return;
    }
    if (!this.rescheduleReason) {
      this.$notify({
        title: 'Warning',
        type: 'warning',
        message: 'Please enter reschedule reason'
      });
      return false;
    }
    if (!(followup !== null && followup !== void 0 && followup.rescheduleTime)) {
      this.$notify({
        title: 'Warning',
        type: 'warning',
        message: 'Please select reschedule time'
      });
      return false;
    }
    const rescheduleTime = followup.rescheduleTime ? (0, _moment.default)(followup.rescheduleTime).format('DD/MM/YYYY HH:mm:ss') : null;
    if (!rescheduleTime) {
      this.$notify({
        title: 'Warning',
        type: 'warning',
        message: 'Invalid reschedule time selected'
      });
      return false;
    }
    this.listLoading = true;
    const res = await (0, _followUps.rescheduleFollowup)({
      id: followup.id,
      rescheduleReason: this.rescheduleReason,
      rescheduleTime
    });
    if (res && res.status === 'success') {
      this.$notify({
        title: 'Success',
        type: 'success',
        message: 'Follow up rescheduled'
      });
    }
    this.rescheduleFollowupVisible = false;
    this.listLoading = false;
    this.rescheduleReason = null; // clear reason after submit
    await this.getList();
    await this.fetchData();
  }
  handleFilter() {
    this.listQuery.page = 1;
    this.getList();
  }
  handleSelectionChange(selectedRows) {
    this.selectedSampleLeadProducts = selectedRows;
  }
  fileUploaded(file) {
    this.lead.poFile = file.response;
  }
  fileRemoved() {
    this.lead.poFile = '';
  }
  imageUploaded(file) {
    // this.sample.sampleLeadProduct[] = file.response
  }
  returnImageUploaded(file, rowIndex) {
    this.sample.sampleLeadProduct[rowIndex].returnedImage = file.response;
  }
  openPODialog() {
    this.fileList = this.lead.poFile ? [{
      name: 'PO Document',
      url: this.lead.poFile
    }] : [];
    this.getPODialogVisible = true;
  }
  async addPODetails() {
    try {
      if (!this.lead.poNumber) {
        this.$notify({
          title: 'Warning',
          type: 'warning',
          message: 'Please Enter PO Number'
        });
        return false;
      }
      console.log('Adding PO details...', this.lead.poNumber, this.lead.poAmount, this.lead.poFile);
      await (0, _leads.addPODetails)(this.lead);
      this.$notify({
        title: 'Success',
        type: 'success',
        message: 'Purchase Order details added successfully'
      });
      this.getPODialogVisible = false;
      this.getList();
      this.fetchData();
      this.$confetti.start();
      setTimeout(() => {
        this.$confetti.stop();
      }, 3000);
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async addSampleLeadProducts() {
    try {
      if (this.selectedSampleLeadProducts.length < 1) {
        this.$message({
          type: 'warning',
          message: 'Please select at least one product for sample'
        });
        return;
      }
      const samplesLeadsProducts = [];
      for (const row of this.selectedSampleLeadProducts) {
        const samplesLeadsProduct = {
          type: row.product.sampleType,
          isReturnExpected: row.product.sampleType === 'Non Consumable',
          leadProductId: row.id,
          productId: row.productId,
          productsVariationId: row.productsVariationId,
          quantity: row.product.quantity
        };
        samplesLeadsProducts.push(samplesLeadsProduct);
      }
      const response = await (0, _samplesLeadsProducts.addBulkSamplesLeadsProducts)({
        bulk: samplesLeadsProducts
      });
      // sample
      const sample = {
        leadId: this.leadId,
        sampleLeadProduct: response,
        initiatedUser: {
          id: this.loggedInUser.id
        },
        assignedUser: {
          id: this.loggedInUser.id
        }
      };
      const samplesResponse = await (0, _samples.createSamples)(sample);
      this.dialogTableVisible = false;
    } catch (error) {
      this.$notify.error({
        title: this.$tc('global.common.error'),
        message: error.message
      });
    } finally {
      this.dialogTableVisible = false;
      this.getList();
    }
  }
  doFollowUp(agenda = null) {
    switch (agenda) {
      case 'Select product options & prepare draft presentation for senior review':
        _router.default.push('/leads/quote/' + this.leadId);
        break;
      case 'Approve draft presentation to send to client':
        _router.default.push('/leads/quote/' + this.leadId);
        break;
      case 'Revise Options':
        _router.default.push('/leads/quote/' + this.leadId);
        break;
      case 'Client options approval':
        this.clientOptionActionDialogVisible = true;
        break;
      case 'Prepare Quotation for Senior  Approval':
        _router.default.push('/leads/quote/' + this.leadId);
        break;
      case 'Source product & add to system':
        this.sourceDialogVisible = true;
        // router.push(`/product/add?followUpRedirect=${this.leadId}`)
        // router.push("/leads/edit/" + this.leadId);
        break;
      case 'Send Quote':
        _router.default.push('/leads/quote/' + this.leadId);
        break;
      case 'Approve prepared Quotation to sent to client':
        _router.default.push('/leads/quote/' + this.leadId);
        break;
      case 'Revise quote':
        _router.default.push('/leads/quote/' + this.leadId);
        break;
      case 'Confirm receipt of Quotation with client':
        this.quoteReceivedDialogTitle = agenda;
        this.quoteReceivedDialogVisible = true;
        break;
      case "Confirm client's reaction on Quote":
        this.clientActionDialogVisible = true;
        break;
      case 'Get Purchase Order':
        this.openPODialog();
        break;
      case 'Arrange Samples':
        this.sampleTitle = 'Arrange Samples';
        this.dialogSampleFollowUpVisible = true;
        // router.push('/leads/sample/' + this.leadId)
        break;
      case 'Arrange Sample Shipment':
        this.sampleTitle = 'Send Sample';
        this.dialogSampleFollowUpVisible = true;
        // router.push('/leads/sample/' + this.leadId)
        break;
      case 'Sample out for Delivery':
        this.sampleTitle = 'Sample out for Delivery';
        this.dialogSampleFollowUpVisible = true;
        // router.push('/leads/sample/' + this.leadId)
        break;
      case 'Sample Delivered':
        this.sampleTitle = 'Sample Delivered';
        this.dialogSampleFollowUpVisible = true;
        // router.push('/leads/sample/' + this.leadId)
        break;
      case 'Arrange Return Pick-up':
        this.sampleTitle = 'Arrange Return Pick-up';
        this.dialogSampleFollowUpVisible = true;
        // router.push('/leads/sample/' + this.leadId)
        break;
      case 'Return Decline Request':
        this.sampleTitle = 'Return Decline Request';
        this.dialogSampleFollowUpVisible = true;
        // router.push('/leads/sample/' + this.leadId)
        break;
      case 'Return Decline Accepted':
        this.sampleTitle = 'Return Decline Accepted';
        this.dialogSampleFollowUpVisible = true;
        // router.push('/leads/sample/' + this.leadId)
        break;
      case 'Return Decline Rejected':
        this.sampleTitle = 'Return Decline Rejected';
        this.dialogSampleFollowUpVisible = true;
        // router.push('/leads/sample/' + this.leadId)
        break;
      case 'Sample out for Return':
        this.sampleTitle = 'Sample out for Return';
        this.dialogSampleFollowUpVisible = true;
        // router.push('/leads/sample/' + this.leadId)
        break;
      case 'Sample Return Delivered':
        this.sampleTitle = 'Sample Return Delivered';
        this.dialogSampleFollowUpVisible = true;
        // router.push('/leads/sample/' + this.leadId)
        break;
      case 'Sample Return Verified':
        this.sampleTitle = 'Sample Return Verified';
        this.dialogSampleFollowUpVisible = true;
        // router.push('/leads/sample/' + this.leadId)
        break;
      default:
        break;
    }
  }
  addSourcedProduct() {
    _router.default.push(`/product/add?followUpRedirect=${this.leadId}`);
  }
  canReopen(lead) {
    if (lead.status !== 'Lost') return false;
    const cutoff = new Date();
    cutoff.setDate(cutoff.getDate() - 30);
    return new Date(lead.lostAt || lead.updatedTimestamp) >= cutoff;
  }
  async handleReopenLead(id) {
    try {
      await this.$confirm('This will change the lead status back to Contacted. Continue?', 'Reopen Lead', {
        confirmButtonText: 'Reopen',
        cancelButtonText: 'Cancel',
        type: 'warning'
      });
      await (0, _leads.reopenLead)(id);
      this.$notify({
        title: 'Success',
        message: 'Lead reopened successfully',
        type: 'success',
        duration: 2000
      });
      this.getList();
    } catch {
      // user cancelled confirmation
    }
  }
  async fetchData() {
    this.sampleListQuery.leadId = this.leadId;
    const data = await (0, _samples.getSamples)((0, _index.getQuery)(this.sampleListQuery));
    this.sample = data[0] || _samples.defaultSampleData;
    if (this.sample.currentStatus === 'Delivered') {
      this.sample.sampleLeadProduct = this.sample.sampleLeadProduct.filter(product => product.type === 'Non Consumable');
    } else if (this.sample.currentStatus === 'Return initiated') {
      this.sample.sampleLeadProduct = this.sample.sampleLeadProduct.filter(product => product.isReturnDeclined === true);
    }
  }
  disableInputs() {
    let readonly = false;
    if (this.loggedInUser.email === 'mubasshir@eiosys.com') {
      readonly = true;
    }
    return readonly;
  }
  async fetchTransporterList() {
    try {
      const data = await (0, _transporters.getTransporters)((0, _index.getQuery)({
        enabled: true,
        sort: 'id,DESC',
        filter: {
          enabled: '$eq'
        }
      }));
      this.transporters = data;
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  promptEditEmail() {
    var _this$lead$clientsCon;
    this.$prompt('Enter new email address:', 'Edit Email', {
      inputValue: ((_this$lead$clientsCon = this.lead.clientsContact) === null || _this$lead$clientsCon === void 0 ? void 0 : _this$lead$clientsCon.emailAddress) || ''
    }).then(({
      value
    }) => {
      // Call your API
      // Change this line inside your .then() block:
      (0, _clientsContacts.updateClientsContact)(this.lead.clientsContact.id, {
        emailAddress: value
      }).then(() => {
        this.lead.clientsContact.emailAddress = value; // Update UI
        this.$message.success('Email updated!');
      }).catch(error => {
        console.error('API Error:', error);
        this.$message.error('Network Error! Check the console.');
      });
    }).catch(() => {}); // ignore cancel
  }
  handleEmailClick() {
    var _this$lead$clientsCon2, _this$lead$clientsCon3;
    const email = (_this$lead$clientsCon2 = this.lead.clientsContact) === null || _this$lead$clientsCon2 === void 0 ? void 0 : _this$lead$clientsCon2.emailAddress;
    if (!email) return;
    const pref = (((_this$lead$clientsCon3 = this.lead.clientsContact) === null || _this$lead$clientsCon3 === void 0 ? void 0 : _this$lead$clientsCon3.communicationPreference) || '').toLowerCase();
    if (pref && !pref.includes('email')) {
      this.emailPrefWarningVisible = true;
      return;
    }
    window.open('mailto:' + email);
  }
  confirmEmailOpen() {
    var _this$lead$clientsCon4;
    this.emailPrefWarningVisible = false;
    window.open('mailto:' + ((_this$lead$clientsCon4 = this.lead.clientsContact) === null || _this$lead$clientsCon4 === void 0 ? void 0 : _this$lead$clientsCon4.emailAddress));
  }
  handleMobileClick() {
    var _this$lead$clientsCon5, _this$lead$clientsCon6;
    const mobile = (_this$lead$clientsCon5 = this.lead.clientsContact) === null || _this$lead$clientsCon5 === void 0 ? void 0 : _this$lead$clientsCon5.mobileNumber;
    if (!mobile) return;
    const pref = (((_this$lead$clientsCon6 = this.lead.clientsContact) === null || _this$lead$clientsCon6 === void 0 ? void 0 : _this$lead$clientsCon6.communicationPreference) || '').toLowerCase();
    if (pref && pref.includes('email') && !pref.includes('phone') && !pref.includes('call') && !pref.includes('whatsapp')) {
      this.mobilePrefWarningVisible = true;
      return;
    }
    window.open('tel:' + mobile);
  }
  confirmMobileOpen() {
    var _this$lead$clientsCon7;
    this.mobilePrefWarningVisible = false;
    window.open('tel:' + ((_this$lead$clientsCon7 = this.lead.clientsContact) === null || _this$lead$clientsCon7 === void 0 ? void 0 : _this$lead$clientsCon7.mobileNumber));
  }
  async sampleArranged() {
    try {
      this.listLoading = true;
      const res = await (0, _samples.sampleArranged)({
        id: this.sample.id
      });
      if (res && res.status === 'success') {
        this.$notify({
          title: 'Success',
          message: res.message,
          type: 'success'
        });
        _router.default.push('/follow-ups/list/' + this.leadId);
      }
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    } finally {
      this.dialogSampleFollowUpVisible = false;
      this.listLoading = false;
      this.getList();
      this.fetchData();
    }
  }
  async sampleCancelled() {
    try {
      this.loading = true;
      const res = await (0, _samples.sampleCancelled)({
        id: this.sample.id
      });
      if (res && res.status === 'success') {
        this.$notify({
          title: 'Success',
          message: res.message,
          type: 'success'
        });
        _router.default.push('/follow-ups/list/' + this.leadId);
      }
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    } finally {
      this.dialogSampleFollowUpVisible = false;
      this.loading = false;
      this.getList();
      this.fetchData();
    }
  }
  async sampleShipped() {
    try {
      this.listLoading = true;
      if (!this.sample.sampleExpectedDeliveryTimestamp) {
        this.$notify({
          title: 'Error',
          type: 'error',
          message: 'Please Select Expected Delivery Date'
        });
        this.listLoading = false;
        return;
      }
      const res = await (0, _samples.sampleShiped)(this.sample);
      if (res && res.status === 'success') {
        this.$notify({
          title: 'Success',
          message: res.message,
          type: 'success'
        });
        _router.default.push('/follow-ups/list/' + this.leadId);
      }
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    } finally {
      this.dialogSampleFollowUpVisible = false;
      this.listLoading = false;
    }
  }
  async sampleDelivered() {
    try {
      this.listLoading = true;
      if (!this.sample.sampleActualDeliveryTimestamp) {
        this.$notify({
          title: 'Error',
          type: 'error',
          message: 'Please Select Actual Delivery Date'
        });
        this.listLoading = false;
        return;
      }
      const res = await (0, _samples.sampleDelivered)(this.sample);
      if (res && res.status === 'success') {
        this.$notify({
          title: 'Success',
          message: res.message,
          type: 'success'
        });
        _router.default.push('/follow-ups/list/' + this.leadId);
      }
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    } finally {
      this.dialogSampleFollowUpVisible = false;
      this.listLoading = false;
    }
  }
  async arrangeReturnPickup() {
    try {
      this.listLoading = true;
      // if (this.sample.sampleLeadProduct.length !== this.selectedreturnProducts.length) {
      //   this.$notify({
      //     title: 'Error',
      //     type: 'error',
      //     message: 'Please Select all products to accept or decline return'
      //   })
      //   this.listLoading = false
      //   return
      // }
      if (!this.sample.sampleReturnDate) {
        this.$notify({
          title: 'Error',
          type: 'error',
          message: 'Please Select a Return Date'
        });
        this.listLoading = false;
        return;
      }
      const sampleFollowUpList = this.followupList.filter(followup => followup.type === 'Sample' && followup.agenda === 'Return Decline Rejected');
      if (sampleFollowUpList.length) {
        const isReturnDeclined = this.sample.sampleLeadProduct.findIndex(item => item.isReturnDeclined === false);
        if (isReturnDeclined) {
          this.$notify({
            title: 'Error',
            type: 'error',
            message: 'Please accept all products to Return'
          });
          this.listLoading = false;
          return;
        }
      }
      this.sample.returnedProducts = this.sample.sampleLeadProduct;
      const res = await (0, _samples.arrangeReturnPickup)(this.sample);
      if (res && res.status === 'success') {
        this.$notify({
          title: 'Success',
          message: res.message,
          type: 'success'
        });
        _router.default.push('/follow-ups/list/' + this.leadId);
      }
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    } finally {
      this.dialogSampleFollowUpVisible = false;
      this.listLoading = false;
    }
  }
  async sampleReturnShipped() {
    try {
      this.listLoading = true;
      if (!this.sample.sampleExpectedReturnDeliveryTimestamp) {
        this.$notify({
          title: 'Error',
          type: 'error',
          message: 'Please Select Expected Return Date'
        });
        this.listLoading = false;
        return;
      }
      const res = await (0, _samples.sampleReturnShipped)(this.sample);
      if (res && res.status === 'success') {
        this.$notify({
          title: 'Success',
          message: res.message,
          type: 'success'
        });
        _router.default.push('/follow-ups/list/' + this.leadId);
      }
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    } finally {
      this.dialogSampleFollowUpVisible = false;
      this.listLoading = false;
    }
  }
  async sampleReturnDelivered() {
    try {
      this.listLoading = true;
      if (!this.sample.sampleActualReturnDeliveryTimestamp) {
        this.$notify({
          title: 'Error',
          type: 'error',
          message: 'Please Select Actual Return Date'
        });
        this.listLoading = false;
        return;
      }
      const res = await (0, _samples.sampleReturnDelivered)(this.sample);
      if (res && res.status === 'success') {
        this.$notify({
          title: 'Success',
          message: res.message,
          type: 'success'
        });
        _router.default.push('/follow-ups/list/' + this.leadId);
      }
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    } finally {
      this.dialogSampleFollowUpVisible = false;
      this.listLoading = false;
    }
  }
  async sampleReturnVerified() {
    try {
      this.listLoading = true;
      const res = await (0, _samples.sampleReturnVerified)(this.sample);
      if (res && res.status === 'success') {
        this.$notify({
          title: 'Success',
          message: res.message,
          type: 'success'
        });
        _router.default.push('/follow-ups/list/' + this.leadId);
      }
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    } finally {
      this.dialogSampleFollowUpVisible = false;
      this.listLoading = false;
    }
  }
  async sampleReturnCompleted() {
    try {
      this.listLoading = true;
      if (!this.sample.sampleReturnCompletedTimestamp) {
        this.$notify({
          title: 'Error',
          type: 'error',
          message: 'Please Select Return Complete Date'
        });
        this.listLoading = false;
        return;
      }
      const res = await (0, _samples.sampleReturnCompleted)(this.sample);
      if (res && res.status === 'success') {
        this.$notify({
          title: 'Success',
          message: res.message,
          type: 'success'
        });
        _router.default.push('/follow-ups/list/' + this.leadId);
      }
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    } finally {
      this.dialogSampleFollowUpVisible = false;
      this.listLoading = false;
    }
  }
  handleReturnSelectionChange(selectedRows) {
    this.selectedreturnProducts = selectedRows;
    if (selectedRows.length < 1) {
      this.sample.sampleLeadProduct.forEach(product => product.isReturnDeclined = false);
      // eslint-disable-next-line no-self-assign
      this.sample = this.sample;
    }
    this.selectedreturnProducts.forEach(row => row.isReturnDeclined = true);
  }
  handleConditionSelectionChange(selectedRows) {
    this.selectedGoodReturnProducts = selectedRows;
    if (selectedRows.length < 1) {
      this.sample.sampleLeadProduct.forEach(product => product.isReturnConditionGood = false);
      // eslint-disable-next-line no-self-assign
      this.sample = this.sample;
    }
    this.selectedGoodReturnProducts.forEach(row => row.isReturnConditionGood = true);
  }
  async saveSample() {
    if (this.sample.currentStatus === 'Arranged') {
      await this.sampleShipped();
    } else if (this.sample.currentStatus === 'Shipped') {
      await this.sampleDelivered();
    } else if (this.sample.currentStatus === 'Delivered') {
      await this.arrangeReturnPickup();
    } else if (this.sample.currentStatus === 'Arrange Return Pick-up') {
      await this.sampleReturnShipped();
    } else if (this.sample.currentStatus === 'Return shipped') {
      await this.sampleReturnDelivered();
    } else if (this.sample.currentStatus === 'Returned Delivered') {
      await this.sampleReturnVerified();
    } else if (this.sample.currentStatus === 'Returned Verified') {
      await this.sampleReturnCompleted();
    }
    this.dialogSampleFollowUpVisible = false;
    this.getList();
    this.fetchData();
  }
  async returnDeclineAccepted() {
    try {
      this.approveLoading = true;
      const res = await (0, _samples.returnDeclineAccepted)(this.sample);
      if (res && res.status === 'success') {
        this.$notify({
          title: 'Success',
          message: res.message,
          type: 'success'
        });
        this.dialogSampleFollowUpVisible = false;
        this.getList();
        this.fetchData();
        _router.default.push('/follow-ups/list/' + this.leadId);
      }
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    } finally {
      this.approveLoading = false;
    }
  }
  async returnDeclineRejected() {
    try {
      this.rejectLoading = true;
      const res = await (0, _samples.returnDeclineRejected)(this.sample);
      if (res && res.status === 'success') {
        this.$notify({
          title: 'Success',
          message: res.message,
          type: 'success'
        });
        this.dialogSampleFollowUpVisible = false;
        this.getList();
        this.fetchData();
        _router.default.push('/follow-ups/list/' + this.leadId);
      }
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    } finally {
      this.rejectLoading = false;
    }
  }
  async clientOptionsUpdate(action = null) {
    try {
      if (action === 'Approve') {
        await this.$confirm('Are you sure you want to approve and send these options to the client?', 'Confirmation', {
          confirmButtonText: 'Yes, Approve',
          cancelButtonText: 'Cancel',
          type: 'warning'
        });
      }
      let res = null;
      switch (action) {
        case 'Approve':
          this.reviseOptionFormVisible = false;
          this.clientOptionActionDialogVisible = false;
          this.listLoading = true;
          res = await (0, _leads.approveClientOptions)({
            id: this.leadId
          });
          break;
        case 'Revise':
          {
            if (!this.reasonId) {
              this.$message({
                type: 'warning',
                message: 'Please select reason'
              });
              return;
            }
            this.reviseOptionFormVisible = false;
            this.clientOptionActionDialogVisible = false;
            this.listLoading = true;
            const selectedReason = this.reasonList.find(reason => reason.id === this.reasonId);
            this.leadRejectReason = selectedReason ? selectedReason.name : '';
            res = await (0, _leads.rejectClientOptions)({
              id: this.leadId,
              reasonId: this.reasonId,
              rejectReason: this.optionRejectReason
            });
            break;
          }
        default:
          break;
      }
      if (res && res.status === 'success') {
        // refresh follow-up list
        this.getList();
        this.$notify({
          title: 'Success',
          message: res.message,
          type: 'success'
        });
        _router.default.push('/follow-ups/list/' + this.leadId);
      }
    } catch (error) {
      if (error !== 'cancel') {
        this.$notify({
          title: 'Error',
          type: 'error',
          message: error.toString()
        });
      }
    } finally {
      this.listLoading = false;
    }
  }
  async clientQuoteUpdate(action = null) {
    try {
      if ((this.rejectFormVisible || this.lostInquiryFormVisible) && action === 'Reject' && !this.leadRejectReason) {
        this.$message({
          type: 'warning',
          message: 'Please select reason'
        });
        return;
      } else if ((this.rejectFormVisible || this.lostInquiryFormVisible) && action === 'Reject' && this.leadRejectReason === 'Other' && !this.leadRejectReasonComment) {
        this.$message({
          type: 'warning',
          message: 'Please enter comments'
        });
        return;
      }
      if (action === 'Approve') {
        await this.$confirm('Are you sure you want to approve ?', 'Confirmation', {
          confirmButtonText: 'Yes, Approve',
          cancelButtonText: 'Cancel',
          type: 'warning'
        });
      }
      const isPORequest = this.getPODialogVisible;
      this.approveFormVisible = false;
      this.rejectFormVisible = false;
      this.reviseFormVisible = false;
      this.clientActionDialogVisible = false;
      this.listLoading = true;
      let res = null;
      switch (action) {
        case 'Approve':
          res = await (0, _leads.approveClientQuote)({
            id: this.leadId
          });
          break;
        case 'Reject':
          res = await (0, _leads.rejectClientQuote)({
            id: this.leadId,
            isSourceRequest: this.sourceDialogVisible,
            isPORequest: isPORequest,
            reasonId: this.reasonId,
            leadRejectReason: this.leadRejectReason,
            leadRejectReasonComment: this.leadRejectReasonComment,
            agenda: this.lostInquiryFormVisible ? this.followupList[0].agenda : null
            // leadRejectReason: this.reasonList.find(
            //   (reason: any) => reason.id === this.reasonId
            // ).name
          });
          break;
        case 'Revise':
          res = await (0, _leads.reviseClientQuote)({
            id: this.leadId,
            quoteReviseReason: this.quoteReviseReason,
            quoteReviseReasonComment: this.quoteReviseReasonComment
          });
          break;
        default:
          break;
      }
      this.lostInquiryFormVisible = false;
      this.getPODialogVisible = false;
      if (res && res.status === 'success') {
        // refresh follow-up list
        this.getList();
        this.$notify({
          title: 'Success',
          message: res.message,
          type: 'success'
        });
        if (action === 'Revise') {
          _router.default.push('/leads/quote/' + this.leadId);
        } else {
          _router.default.push('/follow-ups/list/' + this.leadId);
        }
      }
    } catch (error) {
      if (error !== 'cancel') {
        this.$notify({
          title: 'Error',
          type: 'error',
          message: error.toString()
        });
      }
    } finally {
      this.sourceDialogVisible = false;
      this.getPODialogVisible = false;
      this.listLoading = false;
    }
  }
  async clientQuoteReceiptUpdate(action = null) {
    try {
      if (!this.selectedDate) {
        this.$message({
          type: 'warning',
          message: 'Please select date'
        });
        return;
      }
      this.quoteReceivedDialogVisible = false;
      this.listLoading = true;
      let res = null;
      switch (action) {
        case 'Approve':
          res = await (0, _leads.quoteDelivered)({
            id: this.leadId,
            resendComments: this.resendComments
          });
          break;
        default:
          break;
      }
      if (res && res.status === 'success') {
        // refresh follow-up list
        this.getList();
        this.$notify({
          title: 'Success',
          message: res.message,
          type: 'success'
        });
        _router.default.push('/follow-ups/list/' + this.leadId);
      }
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    } finally {
      this.listLoading = false;
    }
  }
  handleCommand(command, followup) {
    // hide both
    this.rescheduleFollowupVisible = false;
    this.snoozeFollowupVisible = false;
    // set the selected followup
    this.selectedFollowup = followup;
    // show the selected one
    switch (command) {
      case 'snooze':
        this.snoozeFollowupVisible = true;
        break;
      case 'reschedule':
        this.rescheduleFollowupVisible = true;
        break;
      default:
        break;
    }
  }
  getFollowupColour(status = null) {
    switch (status) {
      case 'Completed':
        return 'success';
      // green
      case 'Pending':
        return 'warning';
      // yellow
      case 'Missed':
        return 'danger';
      // red
      case 'Snoozed':
        return 'info';
      // black
      default:
        return '';
      // blue
    }
  }
  getFollowupIcon(status = null) {
    switch (status) {
      case 'Completed':
        return 'el-icon-check';
      case 'Pending':
        return 'el-icon-time';
      case 'Missed':
        return 'el-icon-close';
      case 'Snoozed':
        return 'el-icon-alarm-clock';
      default:
        return 'el-icon-time';
    }
  }
  getFollowupPercentage(dueDate = null) {
    const now = this.$moment(this.now);
    const totalDuration = this.$moment.duration(this.$moment(dueDate).diff(now)).asMilliseconds();
    const fifteenMinutes = 15 * 60 * 1000;
    if (totalDuration <= 0) {
      return 100;
    }
    if (totalDuration > 24 * 60 * 60 * 1000) {
      return 1;
    }
    if (totalDuration <= fifteenMinutes) {
      return 95;
    }
    const progress = 100 - (totalDuration - fifteenMinutes) / (24 * 60 * 60 * 1000 - fifteenMinutes) * 95;
    return Math.max(progress, 5);
  }
  getFollowupTimerColour(dueDate) {
    // Get the progress percentage
    const progress = this.getFollowupPercentage(dueDate);
    // Return a colour based on the progress
    // Green if 100%,
    if (progress >= 100) {
      return '#00FF00'; // Green
    } else if (progress <= 5) {
      return '#FF0000'; // Red
    } else {
      // Otherwise, return a colour between red and green
      const green = Math.round(255 * (progress / 100));
      const red = Math.round(255 * ((100 - progress) / 100));
      return `#${red.toString(16).padStart(2, '0')}${green.toString(16).padStart(2, '0')}00`;
    }
  }
  getPrirityColor(priority) {
    switch (priority) {
      case 'high':
        return 'primary';
      case 'medium':
        return 'warning';
      case 'low':
        return 'success';
      default:
        return '';
    }
  }
  getExtraInfo(followup) {
    var _this$lead$reason, _this$lead$reason2, _this$sample$transpor, _this$sample$returnTr;
    switch (followup.agenda) {
      case 'Revise Options':
        return ((_this$lead$reason = this.lead.reason) === null || _this$lead$reason === void 0 ? void 0 : _this$lead$reason.name) || this.lead.optionsRejectReason;
      case 'Revise quote':
        return ((_this$lead$reason2 = this.lead.reason) === null || _this$lead$reason2 === void 0 ? void 0 : _this$lead$reason2.name) || this.lead.quoteRejectReason;
      case 'Sample out for Delivery':
        return this.sample.deliveryBoyDetails || ((_this$sample$transpor = this.sample.transporter) === null || _this$sample$transpor === void 0 ? void 0 : _this$sample$transpor.name);
      case 'Sample out for Return':
        return this.sample.returnDeliveryBoyDetails || ((_this$sample$returnTr = this.sample.returnTransporter) === null || _this$sample$returnTr === void 0 ? void 0 : _this$sample$returnTr.name);
      case "Confirm client's reaction on Quote":
        if (followup.status === 'Completed' && this.lead.status === 'Lost') {
          return this.lead.leadRejectReason;
        }
        break;
      default:
        return null;
    }
  }
  getSnoozedSpan(followup) {
    var _followup$snoozeTimes;
    // check if followup has been snoozed or rescheduled
    if ((((_followup$snoozeTimes = followup.snoozeTimestamp) === null || _followup$snoozeTimes === void 0 ? void 0 : _followup$snoozeTimes.length) || 0) + followup.rescheduleCount > 0) {
      return 4;
    }
    return 8;
  }
  isDueToday(dueDate) {
    return this.$moment(dueDate).isSame(this.now, 'day');
  }
};
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'FollowupList',
  components: {
    Enabled: _index2.default,
    FollowUpTimer: _FollowUpTimer.default,
    FileUpload: _index3.default
  },
  props: ['endTime']
})], default_1);
var _default = exports.default = default_1;